export default "__VITE_ASSET__DG32BXzd__"